import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAutoSize: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAutoSize"><Path d="M4.5 11.5H12.5V21.5M4.5 11.5V21.5H12.5M4.5 11.5V2.5H19.5V21.5H12.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconAutoSize;
